(function () {
    'use strict';

    angular.module('iMatApp')
        .controller('FileUploadController', FileUploadController);

    FileUploadController.$inject = ['$scope', '$log', 'modelTabWorkflow', 'mainWorkspace', 'eventService', 'upload3DModelTrackEventsService', 'userSettingsService', 'uploadModelConsts'];

    function FileUploadController($scope, $log, modelTabWorkflow, mainWorkspace, eventService, upload3DModelTrackEventsService, userSettingsService, consts) {
        var vm = this;

        vm.file = null;
        vm.units = getSetUnits;
        vm.isTrackProgressSupported = true; // how to automatically check?

        vm.select = select;
        vm.drop = drop;
        vm.cancel = modelTabWorkflow.abortAndResetState;
        vm.getUploadProgress = getUploadProgress;

        activate();

        // -----------------------------------------------------------------------------------
        function activate() {
            eventService.subscribe($scope, consts.eventNames.showBrowseFileDialog, showBrowseFileDialog);
        }

        function getUploadProgress() {
            return mainWorkspace.product.model.uploadingFilePercentage;
        }

        // -----------------------------------------------------------------------------------

        function getSetUnits(value) {
            if (angular.isUndefined(value)) {
                return mainWorkspace.options.units;
            }

            mainWorkspace.options.units = parseInt(value, 10);
            userSettingsService.setUnits(mainWorkspace.options.units);

            return angular.undefined;
        }

        function showBrowseFileDialog() {
            angular.element('#singleUploadFileButton').trigger('click');
        }

        // ----------------------------------- Private functions -----------------------------

        function select(file) {
            if (!file) {
                return;
            }

            upload3DModelTrackEventsService.trackFileSelected();
            modelTabWorkflow.fileSelected(file);
        }

        function drop(file) {
            if (!file) {
                return;
            }

            upload3DModelTrackEventsService.trackFileDropped();
            modelTabWorkflow.fileSelected(file);
        }
    }
})();